export default function isAutoplayAllowed() {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);

  return !reducedMotion && !saveData;
}
